import { computed, inject, Injectable, Signal } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { AppContextService } from './app-context.service';

interface IdTokenClaims {
  name?: string; // John Doe
  given_name?: string; // John
  Title?: string; // Medewerker
  upn?: string; // 1234@partou.nl
  email?: string; // john.doe@partou.nl
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private securityService: OidcSecurityService = inject(OidcSecurityService);
  private appContext: AppContextService = inject(AppContextService);

  private user: Signal<UserDataResult> = this.securityService.userData;

  // Top-level `userData` is null with multiple OIDC configs; per-config entries live in `allUserData`.
  private activeClaims: Signal<IdTokenClaims | null> = computed(() => {
    const activeApplication: string | null = this.appContext.selectedApplication();
    if (!activeApplication) return null;
    const match = this.user().allUserData.find(entry => entry.configId === activeApplication);
    return (match?.userData as IdTokenClaims | undefined) ?? null;
  });

  public name: Signal<string> = computed(() => this.activeClaims()?.name ?? '');

  public firstName: Signal<string> = computed(() => this.name().split(' ')[0] ?? '');

  public jobTitle: Signal<string> = computed(() => this.activeClaims()?.Title ?? this.activeClaims()?.email ?? '');

  public initials: Signal<string> = computed(() =>
    this.name()
      .split(' ')
      .map((segment: string) => segment[0] ?? '')
      .join(''),
  );
}
